/* eslint-disable no-useless-escape */
angular.module('tgaApp').directive('textfit', ['$window', '$timeout',
  function ($window, $timeout) {
    return {
      restrict: 'A',
      scope: {
        // tie a function into the size being used by the directive
        tfReportResult: '&',
        // set to true if element with the directive will have child elements inside
        tfUseChild: '&',
        // use boundingClientRect dimensions for determining resize
        tfUseRect: '&',
        // minimum acceptable font size,never smaller than this
        tfMin: '&',
        // maximum acceptable font size, directive starts here and iterates down
        tfMax: '&',
        // size unit (rem, px, em)
        tfUnit: '&',
        // how much to iterate by each reduction (default 0.1)
        tfIter: '&',
        // further reduce by a static amount after resize (use if it is always just a smidge too big)
        tfReduceAfter: '&',
        // allow controller to override this directive and force it to a certain size
        tfOverrideSize: '=',
      },
      link($scope, $element, attrs) {
        const textFit = () => {
          let els = [$element[0]];
          let parent = $element[0].parentElement;
          const useChildren = angular.isDefined(attrs.tfUseChild);
          const useRect = angular.isDefined(attrs.tfUseRect);

          if (useChildren) {
            if (!$element.children || !$element[0].children[0]) {
              return;
            }
            els = $element[0].children;
            parent = els[0].parentElement;
          }

          const maxFontSize = parseFloat(attrs.tfMax) || 8.0;
          const unit = attrs.tfUnit || 'rem';
          const iter = parseFloat(attrs.tfIter) || 0.1;
          const parentRect = parent.getBoundingClientRect();
          const originalWidth = parentRect.width;
          const originalHeight = parentRect.height;
          // don't process if we can't find box dimensions
          if (!originalWidth || !originalHeight) {
            return;
          }

          // prevent infinite loop with counter
          let count = 0;
          // Binary search for highest best fit
          let size = maxFontSize;
          let checkPassed = false;
          while (checkPassed === false) {
            for (let i = 0; i < els.length; i += 1) {
              els[i].style.fontSize = `${size}${unit}`;
            }
            let totalHeight = 0;
            checkPassed = true;

            for (let i = 0; i < els.length; i += 1) {
              const rect = els[i].getBoundingClientRect();
              const elWidth = useRect ? rect.width : els[i].scrollWidth;
              const elHeight = useRect ? rect.height : els[i].scrollHeight;
              if (elWidth > originalWidth) {
                checkPassed = false;
              }
              totalHeight += elHeight;
            }
            if (totalHeight > originalHeight) {
              checkPassed = false;
            }
            size -= iter;
            count += 1;
            if (count === 1000) {
              break;
            }
          }

          const reduce = angular.isDefined(attrs.tfReduceAfter) ? parseFloat(attrs.tfReduceAfter) : 0;
          size -= reduce;

          if (angular.isDefined(attrs.tfMin)) {
            const min = parseFloat(attrs.tfMin);
            if (min > size) {
              size = min;
            }
          }
          // report the optimal size for this content
          if ($scope.tfReportResult) {
            $scope.tfReportResult({ size, unit });
          }

          // apply font size to elements, override if given value
          let fontSize = `${size}${unit}`;
          if ($scope.tfOverrideSize) {
            const ovSize = parseFloat($scope.tfOverrideSize.split(unit)[0]);
            if (size > ovSize) {
              fontSize = $scope.tfOverrideSize;
            }
          }
          for (let i = 0; i < els.length; i += 1) {
            els[i].style.fontSize = fontSize;
          }
        };
        $scope.$watch(() => $element[0].innerHTML, () => $timeout(() => textFit()));
        $window.addEventListener('resize', () => $timeout(() => textFit()));
        textFit();
      },
    };
  },
]);
